import { createLazyComponent, LazyImport, LazyModule, LazyModuleType } from 'owa-bundling';
import {
    LocalComputerFilePickerProps,
    ILocalComputerFilePicker,
} from './components/LocalComputerFilePicker';
import './mutators/filePickerMutators';

export {
    LocalComputerFilePickerProps,
    ILocalComputerFilePicker,
} from './components/LocalComputerFilePicker';
export { default as AttachmentDataProvider } from 'owa-service/lib/contract/AttachmentDataProvider';
export {
    default as AttachmentDataProviderItem,
} from 'owa-service/lib/contract/AttachmentDataProviderItem';
export {
    default as AttachmentDataProviderScope,
} from 'owa-service/lib/contract/AttachmentDataProviderScope';
export {
    default as AttachmentDataProviderType,
} from 'owa-service/lib/contract/AttachmentDataProviderType';
export {
    default as AttachmentItemsFilterBy,
} from 'owa-service/lib/contract/AttachmentItemsFilterBy';
export {
    default as AttachmentItemsPagingMetadata,
} from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
export { default as AttachmentItemsSort } from 'owa-service/lib/contract/AttachmentItemsSort';
export { default as FilePickerAction } from './store/schema/FilePickerAction';
export { default as FilePickerConfiguration } from './store/schema/FilePickerConfiguration';
export { default as FilePickerResult, SelectedFilesSource } from './types/FilePickerResult';
export {
    default as FilePickerUploadConfiguration,
    ComposeUniqueState,
} from './store/schema/FilePickerUploadConfiguration';
export {
    default as GetAttachmentDataProviderItemsResponse,
} from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
export { default as getDefaultFileProvider } from './actions/helpers/getDefaultFileProvider';
export { default as GetFileProviderItemsResponse } from './types/GetFileProviderItemsResponse';
export {
    default as RemoveAttachmentDataProviderResponse,
} from 'owa-service/lib/contract/RemoveAttachmentDataProviderResponse';
export { default as RequestOriginType } from 'owa-service/lib/contract/RequestOriginType';
export { ActionsPanelState } from './actionsPanel';
export { AddableFileProviderInfo } from 'owa-fileprovider-store';
export { FilePickerViewType } from './types/FilePickerViewSwitcher';
export { FileProviderViewState, FileSelectionFilter } from 'owa-fileprovider-store';
export {
    default as FilePickerUserConfiguration,
    AttachOrSharePreference,
    FilePickerUserConfigurationProperty,
} from './store/schema/FilePickerUserConfiguration';
export {
    default as FileProviderItemViewState,
    FileProviderItemType,
} from './store/schema/FileProviderItemViewState';
export {
    FacebookDataProviderItemType,
    FacebookProviderScopeType,
    SizeLimitInKbToSuggestSharing,
} from './utils/filePickerConstants';

/* This package SHOULD contain minimal attachment related logic. It should NOT take any dependencies on the attachment package.
   It is supposed to be self contained and possibly reusable outside OWA for picking files from different providers */
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FilePicker", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded components
export const LocalComputerFilePicker = createLazyComponent<
    LocalComputerFilePickerProps,
    LazyModuleType<typeof lazyModule>,
    ILocalComputerFilePicker
>(lazyModule, m => m.LocalComputerFilePicker);

// Delay loaded imports
export const lazyFilePicker = new LazyImport(lazyModule, m => m.filePicker);
export const lazyActionsPanel = new LazyImport(lazyModule, m => m.actionsPanel);
export const lazyGetFileProviderItems = new LazyImport(lazyModule, m => m.getFileProviderItems);

export const lazyCreateFileProviderItemsViewState = new LazyImport(
    lazyModule,
    m => m.createFileProviderItemsViewState
);

export const lazyPreloadFilePicker = new LazyImport(lazyModule, m => m.preloadFilePicker);
export const lazyGetUserPreferredFilePickerAction = new LazyImport(
    lazyModule,
    m => m.getUserPreferredFilePickerAction
);
